class ReportService {
    static $inject = ['$http', '$window', 'stToast'];

    /**
     * @param {ng.IHttpService} $http
     * @param {ng.IWindowService} $window
     * @param {StToast} toast
     */
    constructor($http, $window, toast) {
        this.$http = $http;
        this.$window = $window;
        this.toast = toast;

        this.ie = navigator.userAgent.match(/Edge|\.NET|MSIE/g);
    }

    getShippingLabel = order => {
        const popup = this.createPopup(`Shipping Label`);

        return this.$http.get(`/api/v1/reports/shipping-label/${order.return_id}`,
            { responseType: "arraybuffer" } /*This is important to open the file*/)
            .then(result => this.openGifReport(result.data, `${order.tracking_number}`, popup))
            .catch(err => this.handleError(popup, err));
    };

    getPackListRpt = orderId => {
        const popup = this.createPopup(`Pack List - ${orderId}`);

        return this.$http.get(`/api/v1/reports/pack-list/${orderId}`,
            { responseType: "arraybuffer" } /*This is important to open the pdf*/)
            .then(result => this.openPdfReport(result.data, `${orderId}.pdf`, popup))
            .catch(err => this.handleError(popup, err));
    };

    createReport(fileName, parameters) {
        return this.$http
            .post(window.Pims.apis.reporting + '/reports', {
                'ConnectionName': 'mfgdb',
                'FileName': fileName,
                'TypeOfReport': 0,
                'Parameters': parameters
            })
            .then(result => this.$window.open(result.data.Uri, '_blank'))
            .catch(this.toast.errorHandler);
    }

    createBarcodeReport(fileName, parameters, barcodeValues, optionsBarcodeSettings = {}) {
        const defaultBarcodeSettings = {
            'BarcodeType': 1,
            'Width': 1.0,
            'Height': 1.0,
            'DisplayCode': false
        };

        const barcodeSettings = angular.extend({}, defaultBarcodeSettings, optionsBarcodeSettings);
        return this.$http
            .post(window.Pims.apis.reporting + '/singlebarcodereports',
                {
                    'ConnectionName': 'mfgdb',
                    'FileName': fileName,
                    'TypeOfReport': 0,
                    'Parameters': parameters,
                    'BarcodeSettings': barcodeSettings,
                    'BarcodeValues': barcodeValues
                })
            .then(result => this.$window.open(result.data.Uri, '_blank'))
            .catch(this.toast.errorHandler);
    };

    createPopup = title => {
        let popup = undefined;
        if (!this.ie) {
            popup = window.open("", title);
            popup.document.body.append(popup.document.createElement('div').innerHtml = 'Loading...');
        }
        return popup;
    }

    handleError = (popup, err) => {
        if (popup) popup.close();
        throw err;
    };

    openPdfReport = (data, filename, popup) => {
        const file = new Blob([data], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(file);

        if (this.ie) {
            window.navigator.msSaveBlob(file, filename);
        } else {
            popup.location.href = fileUrl;
        }
    };

    openGifReport = (data, filename, popup) => {
        const file = new Blob([data], { type: "image/gif" });
        const fileUrl = URL.createObjectURL(file);

        if (this.ie) {
            window.navigator.msSaveBlob(file, filename);
        } else {
            //popup.location.href = fileUrl;
            popup.document.body.innerText = "";
            const img = popup.document.createElement('img');
            img.src = fileUrl;
            popup.document.body.append(img);
        }
    };
}

angular
    .module('app')
    .service('reportService', ReportService);
